
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import Index from "./pages/Index";
import About from "./pages/About";
import Skills from "./pages/Skills";
import Projects from "./pages/Projects";
import Resume from "./pages/Resume";
import Blog from "./pages/Blog";
import Testimonials from "./pages/Testimonials";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Playground from "./pages/Playground";
import NotFound from "./pages/NotFound";
import BlogPost from './pages/BlogPost';
import Terms from './pages/Terms';
import Security from './pages/Security';
import CookieConsent from './components/CookieConsent';
import { TestimonialProvider } from '@/context/TestimonialContext';
import { ColleagueProvider } from '@/context/ColleagueContext';
import { EbookProvider } from '@/context/EbookContext';
import { BlogProvider } from '@/context/BlogContext';
import { AuthProvider } from '@/context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TestimonialProvider>
        <ColleagueProvider>
          <EbookProvider>
            <BlogProvider>
              <CookieConsent />
              <TooltipProvider>
                <Helmet>
                  <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
                  <meta name="theme-color" content="#3b82f6" />
                  <meta name="apple-mobile-web-app-capable" content="yes" />
                  <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
                  <meta name="format-detection" content="telephone=no" />
                  <link rel="sitemap" type="application/xml" href="/sitemap.xml" />
                </Helmet>
                <Toaster />
                <Sonner />
                <BrowserRouter>
                  <Routes>
                    <Route path="/" element={<Index />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/skills" element={<Skills />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/resume" element={<Resume />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/testimonials" element={<Testimonials />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/playground" element={<Playground />} />
                    <Route path="/blog/:slug" element={<BlogPost />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/security" element={<Security />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/dashboard" element={
                      <ProtectedRoute>
                        <Dashboard />
                      </ProtectedRoute>
                    } />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </BrowserRouter>
              </TooltipProvider>
            </BlogProvider>
          </EbookProvider>
        </ColleagueProvider>
      </TestimonialProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
